import styled from 'styled-components';
import { BodyRegularM, BodyRegularS, CaptionRegularM } from '../../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../../styles/theme';

export const AccordionComponentCont = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;

  ${({ theme }: IThemeProvider) => `
    padding: 0 16px 0 92px;
    border-top: 1px solid ${theme.colors.neutral.primary[30]};
  `};
`;

export const AccordionTableTileCont = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: space-between;

  ${({ theme }: IThemeProvider) => `
    // padding: 0 30px 0 96px;
    color: ${theme.colors.neutral.primary[80]};
  `};
`;
interface IAccArrowCont {
  active?: boolean;
  theme: ITheme;
}

export const AccArrowCont = styled.div<IAccArrowCont>`
  width: 34px;
  height: 24px;
  display: flex;
  align-items: center;
  svg {
    height: 12px;
    position: relative;
    top: -2px;

    ${({ active }) => `
      ${
  active
    ? `
        transform: rotate(90deg);
        top: -2px;
      `
    : ''
}
  `};
  }
`;

export const TileAccSide = styled.div`
  position: relative;
  display: flex;
  height: 52px;
  align-items: center;
  flex: 2;

  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.decy} 0 0;
  `}
`;

export const TileAccRightSide = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 52px;
  cursor: pointer;
  flex: 3;
`;

export const AccTitle = styled(BodyRegularS)`
  position: relative;
  display: flex;
  font-weight: 500;
  width: 100%;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[90]};
  `};

  //@media (min-width: 1360px) {
  //  width: 425px;
  //}
`;

export const ScoreVal = styled(BodyRegularM)`
  min-width: 95px;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `};
`;

export const RepAccTileBodyCont = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  max-width: 100%;

  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.mili} ${theme.layout.spacing.decy};
  `};
`;

interface ITileAccBodyContent {
  theme: ITheme;
  margin?: string;
}

export const TileAccBodyContent = styled(CaptionRegularM)<ITileAccBodyContent>`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;

  ${({ theme }: ITileAccBodyContent) => `
    margin: 0 0 ${theme.layout.spacing.mili} 0;
    color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const SideContentCont = styled.div`
  position: relative;
`;

export const ExampleStatementCont = styled.span`
  margin-top: 14px;
`;

export const ExampleStatementTitle = styled.span`
  font-weight: 700;
`;

export const ExampleStatement = styled(CaptionRegularM)`
  font-style: italic;
`;
